import { render, staticRenderFns } from "./NominationResults.vue?vue&type=template&id=ecd05ad0"
import script from "./NominationResults.vue?vue&type=script&lang=js"
export * from "./NominationResults.vue?vue&type=script&lang=js"
import style0 from "./NominationResults.vue?vue&type=style&index=0&id=ecd05ad0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports